import { render, staticRenderFns } from "./side-navigation.vue?vue&type=template&id=2ee60f55&scoped=true"
import script from "./side-navigation.vue?vue&type=script&lang=js"
export * from "./side-navigation.vue?vue&type=script&lang=js"
import style0 from "./side-navigation.vue?vue&type=style&index=0&id=2ee60f55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee60f55",
  null
  
)

export default component.exports